import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from "@angular/router";


@Component({
    selector: 'app-page-header',
    templateUrl: './page-header.component.html',
    styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent implements OnInit {

    selectedMenuItem = 'Applications';


    @Input() name: string;
    @Input() buttonDisabled: boolean;
    @Input() showButton: boolean = true;
    @Input() buttonText: string = 'Salva';
    @Input() icon: string = 'save';
    @Input() showBreadcrumb: boolean;
    @Input() selectedDashboardArea: any;
    @Input() showDashboardAreaMenu: boolean;
    @Input() showMainMenu: boolean;
    @Input() mainMenuPrefix: string;

    @Output() onSave = new EventEmitter<any>();
    @Output() onAction = new EventEmitter<void>();
    @Output() onChangeDashboardArea = new EventEmitter<any>();


    constructor(
                private router: Router) {
    }

    triggerAction() {
        this.onAction.emit();
        this.onSave.emit();
    }

    ngOnInit(): void {
    }

    changeDashboardArea(overview: string) {
        this.onChangeDashboardArea.emit(overview);
    }

    navigateMenu(menuItem, route: string) {
        this.selectedMenuItem = menuItem;
        this.router.navigate([this.mainMenuPrefix + route])
    }
}
